export default "__VITE_ASSET__ClGdqLgc__"